<ng-template #content let-modal>
    <div class="modal-header">
        <div class="row w-100 text-center">
            <div class="col-12">
                <h4 class="modal-title">{{ "workflow.override_monitored_decision" | translate }}</h4>
            </div>
            @if (objectName()) {
                <div class="col-12">
                    <h6 class="modal-title">({{ objectName() }})</h6>
                </div>
            }
        </div>

        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body p-2 px-2 overflow-x-hidden position-relative z-0">
        <adaa-wf-override-decision [data]="data()" [categories]="actionCategories()" (emitDecision)="decision.set($event)" />
        <adaa-form-input-file
            [onDeleteRemoveFile]="false"
            [allowedFileSize]="10000000"
            [allowedFiles]="allowedFiles"
            (inputChanges)="attachment.set($event)"
        />
    </div>

    <div class="modal-footer d-flex w-100 justify-content-center align-items-center bg-card" style="--bs-btn-hover-color: var(--bs-white)">
        <button class="btn btn-danger text-white fw-bold mx-3 px-4" [disabled]="isButtonsDisabled" (click)="submitDecision(wfActionType.REJECTED)">
            {{ "common.form.button.reject" | translate }}
        </button>

        <button
            class="btn btn-lg btn-primary fw-bold text-white mx-1 px-5"
            [disabled]="isButtonsDisabled"
            (click)="submitDecision(wfActionType.APPROVED)"
        >
            {{ "workflow.override_button" | translate }}
        </button>
    </div>
</ng-template>
